import UnlockIcon from '../../assets/unlock.svg'
import LockIcon from '../../assets/lock.svg'
import { useLockControllerLog } from '../../api/useLockControllerLog'
import { Log, MileageLossCode } from '@/types/logs'
import clsx from 'clsx'
import styles from './Lock.module.scss'
import { useCombinedLogsTableStateStore } from '../../store'
import { checkLockPermissions } from '../../helpers/checkLockPermissions'

export const Lock = ({ id, log }: { id: string; log: Log }) => {
    const { handleLockControllerLog } = useLockControllerLog()
    const { multipleSelection } = useCombinedLogsTableStateStore()
    const isAbleToLock = checkLockPermissions(log)

    const handleLockClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (multipleSelection.length) {
            const recordsToLock = multipleSelection.filter(checkLockPermissions)

            const isAllLocked = recordsToLock.every((row) => row.isLocked)

            if (isAllLocked) {
                handleLockControllerLog(
                    recordsToLock.map((row) => ({
                        id: row.id,
                        isLocked: false,
                    }))
                )
            } else {
                handleLockControllerLog(
                    recordsToLock.map((row) => ({
                        id: row.id,
                        isLocked: true,
                    }))
                )
            }
        } else {
            if (isAbleToLock) {
                handleLockControllerLog([
                    {
                        id,
                        isLocked: !log.isLocked,
                    },
                ])
            }
        }
    }

    if (!(log.code in MileageLossCode)) {
        return null
    }

    return (
        <div className={styles.root}>
            <button onClick={handleLockClick} type="button" className={clsx({ [styles.disabled]: !isAbleToLock })}>
                {log.isLocked ? <LockIcon /> : <UnlockIcon />}
            </button>
        </div>
    )
}
